<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>语言学校列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="content">
      <el-form
        inline
        :model="query"
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList()"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList();">查询</el-button>
          <el-button
            type="success"
            @click="dialogVisible=true;form={isEnable:true};selectedOptions=[];monthList=[];labelList=[];"
          >新增</el-button>
        </el-form-item>
      </el-form>

      <!-- 主体 -->
      <el-card class="box-card table">
        <div class="clearfix" slot="header">
          <span>语言学校列表</span>
        </div>

        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%"
          @sort-change="sortChange"
          @filter-change="filterTag"
        >
          <el-table-column label="学校名称">
            <template slot-scope="scope">
              <a :href="scope.row.url" target="_blank">{{scope.row.name}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="natureName" label="学校性质"></el-table-column>
          <el-table-column prop="siteName" label="地区">
            <template slot-scope="scope">{{scope.row.provinceName}} {{scope.row.cityName}}</template>
          </el-table-column>
          <el-table-column prop="fixedCount" label="定员人数"></el-table-column>
          <el-table-column prop="tuitionFee" label="学费"></el-table-column>
          <el-table-column label="是否推荐">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isRecommend" type="success">是</el-tag>
              <el-tag v-else type="warn">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="viewCount" label="浏览次数"></el-table-column>
          <el-table-column prop="createTime" label="添加时间"></el-table-column>

          <!-- 操作 -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="warning"
                    size="small"
                    icon="el-icon-delete"
                    @click="delClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="宿舍图片" placement="top">
                  <el-button
                    type="success"
                    size="small"
                    icon="el-icon-picture-outline"
                    @click="imgClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-size="pageSize"
            :page-sizes="[10,20,30,50,100]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 弹框 -->
    <el-dialog
      :title="form.id>0?'编辑学校':'添加学校'"
      :visible.sync="dialogVisible"
      @opened="dialogOpened()"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="110px"
        :status-icon="true"
        @submit.native.prevent="submitForm(form)"
      >
        <el-tabs type="card">
          <el-tab-pane label="基本信息">
            <el-form-item prop="name" label="学校名称" :rules="[{required:true,message:'不能为空'}]">
              <el-input v-model="form.name" placeholder="请输入关键词"></el-input>
            </el-form-item>

            <el-form-item label="Logo" :rules="[{required:true,message:'不能为空'}]">
              <div
                id="uploadBtn9"
                class="uploader uploader-warning"
                style="position:absolute;top:5px;"
              ></div>
              <img
                id="relativeName"
                :src="domain+form.logo"
                alt
                style="width:50px;position:relative;left:100px;top:5px;"
                v-if="form.logo"
              />
              <span class="uploadslot">*图片尺寸：160*120</span>
            </el-form-item>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="地区" :rules="[{required:true,message:'不能为空'}]">
                  <el-cascader
                    :options="arealist"
                    v-model="selectedOptions"
                    clearable
                    filterable
                    :props="{value:'areaID',label:'areaName'}"
                    style="width:100%;"
                  ></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="nature" label="学校性质" :rules="[{required:true,message:'不能为空'}]">
                  <el-select
                    v-model="form.nature"
                    clearable
                    placeholder="请选择学校性质"
                    style="width:100%;"
                  >
                    <el-option
                      v-for="item in naturelist"
                      :label="item.name"
                      :key="item.id"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item
                  prop="fixedCount"
                  label="定员人数"
                  :rules="[{required:true,message:'不能为空'}]"
                >
                  <el-input type="number" v-model.number="form.fixedCount" placeholder="请输入定员人数"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  prop="chinesePercent"
                  label="中国学生比例"
                  :rules="[{required:true,message:'不能为空'}]"
                >
                  <el-input
                    type="number"
                    v-model.number="form.chinesePercent"
                    placeholder="请输入学生比例"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item
                  prop="tuitionFee"
                  label="学费"
                  :rules="[{required:true,message:'不能为空'}]"
                >
                  <el-input type="number" step="0.01"  v-model.number="form.tuitionFee" placeholder="单位：万日元"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="开学月份" :rules="[{required:true,message:'不能为空'}]">
                  <el-select v-model="monthList" multiple placeholder="请选择月份" style="width:100%;">
                    <el-option
                      v-for="item in monthlist"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item prop="buildingTime" label="建校时间" :rules="[{required:true,message:'不能为空'}]">
              <el-input type="number" v-model.number="form.buildingTime" placeholder="请输入建校年份"></el-input>
            </el-form-item>

            <el-form-item label="学校特色" :rules="[{required:true,message:'不能为空'}]">
              <el-select v-model="labelList" multiple placeholder="请选择标签" style="width:100%;">
                <el-option
                  v-for="item in labellist"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="siteDetail" label="详细地址">
              <el-input type="textarea" v-model="form.siteDetail" placeholder="请输入详细地址"></el-input>
            </el-form-item>

            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item prop="isRecommend" label="是否推荐">
                  <el-switch v-model="form.isRecommend"></el-switch>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="18">
                <el-form-item label="宣传册">
                  <div id="uploadBtn10" class="uploader uploader-warning"></div>
                  <span id="relativeName1" style="margin-left:20px;">{{form.fileUrl}}</span>
                  <span
                    class="imgtext"
                    title
                    type="info"
                    style="position:relative;left:0px;top:1px;"
                  >*文件格式：pdf</span>
                </el-form-item>
              </el-col> -->
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="详情信息">
            <el-form-item prop="condition" label="入学资格">
              <el-input type="textarea" v-model="form.condition" placeholder="请输入入学资格"></el-input>
            </el-form-item>

            <el-form-item prop="feeDetail" label="费用详情">
              <el-input type="textarea" v-model="form.feeDetail" placeholder="请输入费用详情"></el-input>
            </el-form-item>

            <el-form-item prop="dormDetail" label="宿舍详情">
              <el-input
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 10 }"
                v-model="form.dormDetail"
                placeholder="请输入宿舍详情"
              ></el-input>
            </el-form-item>

            <el-form-item prop="content" label="学校简介:">
              <div style="position:relative;">
                <vue-ueditor-wrap v-model="form.content" :config="editorConfig"></vue-ueditor-wrap>
              </div>
            </el-form-item>
          </el-tab-pane>
          <el-form-item>
            <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
            <el-button @click="dialogVisible=false">取消</el-button>
          </el-form-item>
        </el-tabs>
      </el-form>
    </el-dialog>
  </div>
</template>


<script>
import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module
import url from "@/plugins/urlHelper.js";
import json from "@/plugins/jsonHelper.js";
import "../../../public/lib/cover/Cover3.0.min.css";
import "../../../public/lib/cover/Cover3.0.min.js";
export default {
  data() {
    return {
      domain: url.getDomain(),
      query: {},
      form: {},
      dialogVisible: false,
      loading: false,
      submiting: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage4: 1,
      content: "",
      editorConfig: {
        zIndex: 3000, //配置控件组件弹出层
        initialFrameHeight: 300, //设置高度
        initialFrameWidth: "100%", //设置宽度
        UEDITOR_HOME_URL: url.getUEConfig(),
        serverUrl: url.getUE()
      },
      selectedOptions: [],
      arealist: [],
      naturelist: [], //学校性质
      monthlist: [],
      labellist: [],
      monthList: [],
      labelList: []
    };
  },
  methods: {
    handleSizeChange: function(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange: function(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //   筛选
    filterTag: function(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      this.getList();
    },
    //   排序
    sortChange: function(sortColumn) {
      this.query.sort = sortColumn.sort;
      this.query.order = sortColumn.order;
      this.getList();
    },
    // 地区
    getAreaList: function() {
      var _this = this;
      var link = url.getCommon("getarea_Japan");
      $.get(link, {}, data => {
        _this.arealist = data;
      });
    },
    // 学校性质
    getNatrueList: function() {
      var _this = this;
      _this.naturelist = json.getSchNature();
    },
    //开学月份
    getMonthList: function() {
      var _this = this;
      _this.monthlist = json.getMonth();
    },
    // 标签
    getLabelList: function() {
      var _this = this;
      var link = url.getCommon("getlabel");
      $.get(link, {}, data => {
        _this.labellist = data;
      });
    },
    //   列表
    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageSize = _this.pageSize;
      params.pageIndex = _this.currentPage4;
      var link = url.getSch("getlist_school");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    // 查询
    selList: function() {
      this.currentPage4 = 1;
      this.getList();
    },
    // 编辑
    editClick: function(row) {
      var _this = this;
      _this.dialogVisible = true;
      var id = row.id;
      var link = url.getSch("getmodel_school");
      $.get(link, { id: id }, data => {
        if(data)data=JSON.parse(data);
        data.content=data.content||'';
        _this.form = data;
        _this.selectedOptions = [data.provinceID, data.cityID];
        _this.monthList = data.monthList.split(",");
        var lalist = data.labelList.split(",");

        var str = [];
        for (var i = 0; i < lalist.length; i++) {
          var item = lalist[i];
          var list = parseInt(item);
          str.push(list);
        }
        _this.labelList = str;
      });
    },
    // 跳转
    imgClick: function(row) {
      var id = row.id;
      var name = row.name;
      this.$router.push({
        name: "image",
        query: { id: id, name: name }
      });
    },
    // 删除
    delClick: function(row) {
      var _this = this;
      var link = url.getSch("delete_school");
      var id = row.id;

      this.$confirm("确定眼删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $.post(link, { id: id }, res => {
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList(),
                _this.$message({
                  type: "success",
                  message: res.msg
                });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 上传
    dialogOpened: function() {
      var _this = this;
      // 上传图片
      if ($("#uploadBtn9 input").length == 0) {
        $("#uploadBtn9").uploader({
          url: url.getUpload(),
          fileExts: "jpg;png",
          type: "dialog",
          text: "上传图片",
          maxSize: 1024 * 1024 * 1, //上传图片最大值
          subfolder: "content", //默认后台处理简单模式 ，指定子文件夹
          more: false, //是否可以上传多个
          auto: true, //是否自动上传
          coverParams: {
            title: "上传图片",
            targetWidth: 160,
            targetHeight: 120
          },
          onSuccess: function(data) {
            var src = url.getDomain() + data.relativeName;
            _this.$set(_this.form, "logo", data.relativeName);
          }
        });
      }

      // 上传文件
      // if ($("#uploadBtn10 input").length == 0) {
      //   $("#uploadBtn10").uploader({
      //     url: url.getUpload(),
      //     text: "上传文件",
      //     fileExts: "pdf",
      //     handleType: "0",
      //     debug: false,
      //     maxSize: 1024 * 1024 * 30, //上传文件最大值
      //     //开始上传验证扩展
      //     onSuccess: function(data) {
      //       var relativeName1 = data.relativeName; //解决其他js时间中的vue数据同步问题
      //       _this.$set(_this.form, "fileUrl", relativeName1);
      //     }
      //   });
      // }
    },
    // 提交
    submitForm: function(formName) {
      var _this = this;
      var link = url.getSch("save_school");
      var info = _this.form;

      //提交之前验证
      if (!info.logo) {
        _this.$message({
          type: "error",
          message: "请上传logo"
        });
        return;
      }
      if (this.selectedOptions.length <= 0) {
        _this.$message({
          type: "error",
          message: "请选择学校地区"
        });
        return;
      }
      if (this.monthList.length == 0) {
        _this.$message({
          type: "error",
          message: "请选择开学月份"
        });
        return;
      }
      if (this.labelList.length == 0) {
        _this.$message({
          type: "error",
          message: "请选择服务"
        });
        return;
      }
      info.provinceID = this.selectedOptions[0];
      info.cityID = this.selectedOptions[1];
      info.monthList = this.monthList.toString();
      info.labelList = this.labelList.toString();

      this.$refs.form.validate(valid => {
        if (valid) {
          _this.submiting = true;

          // 提交后台  添加或修改
          $.post(link, info, res => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          return false;
        }
      });
    }
  },
  components: {
    VueUeditorWrap
  },
  mounted() {
    //   地区
    this.getAreaList();
    // 学校性质
    this.getNatrueList();
    // 开学月份
    this.getMonthList();
    // 特色
    this.getLabelList();
    // 列表
    this.getList();
  }
};
</script>